<div class="modal-body">
    <div class="row">
        <div class="col">
            <p *ngIf="JoiningDate != null && JoiningDate != ''"><strong>Joining Date:</strong> {{ JoiningDate }}</p>
        </div>
        <div class="col">
            <p *ngIf="LeftDate != null && LeftDate != ''"><strong>Left Date:</strong> {{ LeftDate }}</p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="close(false)"><i class="bi bi-x"></i> Close</button>
</div>